import { StructError, create } from 'superstruct';
import { Payload } from './payload';
export { ItemsAddedToCart } from './response';
export const makeAddItemsToCart = function() {
    return async function addItemsToCart(rawPayload) {
        try {
            const payload = create(rawPayload, Payload);
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            if (!response.ok) {
                const details = await response.json();
                console.warn(details, {
                    payload: rawPayload
                });
                throw new Error(details.description || details.message || 'Cart Error');
            }
            return await response.json();
        } catch (err) {
            if (err instanceof StructError) {
                console.error(err, {
                    payload: rawPayload
                });
                throw new Error('Internal validation error');
            }
            // Re-throw if it's already our custom error from the response handling
            if (err instanceof Error && err.message !== 'Internal error') {
                throw err;
            }
            throw new Error('Internal error');
        }
    };
};
